// @givmo/app-charity — the person's "Sign-in & security" card on this console (AS-WEB11; D-AS-21's
// A4 placement: first under Settings › Your settings).
//
// `@givmo/passkeys`' card, which renders nothing until the backend serves the passkey surface here,
// on this console's "Confirm it's you" host, so adding or removing a passkey meets the factor rules
// through the shared sheet. Nor does it render on a page host no passkey can work on (EP-MNT18,
// `passkeysUsableHere`: off `givmo.io`, as a raw `*.web.app` host is), where the browser would refuse
// every ceremony it offers. Under a console-wide `StepUpHostProvider` its gates use that host, so a
// refusal beside another module's on the same page (Settings also carries other modules' cards)
// meets the one prompt that provider draws, never a second sheet stacked on it; only where no
// provider is above it does it provide the console's host itself. The account menu's
// "Sign-in & security" row leads here (`#sign-in-security`), and only while the same read is served.
// The console's authenticator primitives ride along (AS-WEB14), so the card's authenticator rows can
// act for an account the web offers one to.

import { SignInSecurityCard, passkeysUsableHere } from '@givmo/passkeys';
import { StepUpHostProvider, useOptionalStepUpHost } from '@givmo/step-up';
import { useAuth } from '../../auth/auth-context';
import { useCharityStepUpHost } from '../step-up/charity-step-up-host';

export function CharitySignInSecurityCard() {
  const { user, authenticator } = useAuth();
  const provided = useOptionalStepUpHost();
  const host = useCharityStepUpHost();
  if (!passkeysUsableHere()) return null;
  const card = (
    <SignInSecurityCard
      uid={user?.uid ?? null}
      {...(authenticator !== undefined ? { authenticator } : {})}
    />
  );
  return provided === null ? <StepUpHostProvider adapter={host}>{card}</StepUpHostProvider> : card;
}
